var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDynamicPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1C2.44772 1 2 1.44772 2 2V18C2 18.5523 2.44772 19 3 19H12V14C12 13.4477 12.4477 13 13 13H18V2C18 1.44772 17.5523 1 17 1H3ZM7.50333 5.64071L6.26166 8.86581C6.13557 9.19333 6.37732 9.54545 6.72828 9.54545H7.93948C8.27839 9.54545 8.51911 9.8755 8.41558 10.1982L7.15489 14.1276C7.07712 14.37 7.36909 14.56 7.5592 14.3907L12.0192 10.4189C12.3624 10.1132 12.1463 9.54545 11.6867 9.54545H11.1033C10.7523 9.54545 10.5106 9.19333 10.6367 8.86581L11.8633 5.67965C11.9894 5.35212 11.7477 5 11.3967 5H8.43655C8.0229 5 7.65195 5.25468 7.50333 5.64071Z",
    fill: "#2A4384",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14V19L18 13H13C12.4477 13 12 13.4477 12 14Z",
    fill: "#1F305E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDynamicPage);
export default __webpack_public_path__ + "static/media/icon-dynamic-page.813cd5be2adcc4789da63856867129ba.svg";
export { ForwardRef as ReactComponent };